import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// native components
import ClientServicesHours7to6 from '../../../components/clientServicesHours7to6';
import ClientServicesPhone4644, { clientServicesPhoneNumberLinkUrl } from '../../../components/clientServicesPhone4644/clientServicesPhone4644';
// styles
import { LinkStyled } from './styles';

export default () => {
  return (
    <SectionContainer
      id='delete-account-contact-info'
      backgroundVariant='lightB'
      themeType='lightTheme'
      moduleName='intro-module'
      moduleVariation='A'>
      <Row align='center'>
        <Col
          medium={10}
          large={8}
          align='center'>
          <Typography
            component='h1'
            nextElement='link'
            align='center'>
            Contact Support
          </Typography>
          <LinkStyled
            id='contact-support-phone-number-link'
            variant='primaryDeemphasize'
            linkUrl={clientServicesPhoneNumberLinkUrl}
            noWrap>
            <ClientServicesPhone4644 />
          </LinkStyled>
          <Typography nextElement='typography'>
            <ClientServicesHours7to6 />
          </Typography>
          <Typography nextElement='typography'>
            Have your policy or account number handy, if available.
          </Typography>
          <Typography disableBottomPadding>
            If you have questions about our data retention practices please contact Support.
          </Typography>
        </Col>
      </Row>
    </SectionContainer>
  );
};
